import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { UpdateSubsetRequestDto } from '../../../../backend/src/subset/dto/update-subset.request.dto';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useUpdateSubset = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      matterId,
      subsetId,
      body,
    }: {
      matterId: string;
      subsetId: string;
      body: UpdateSubsetRequestDto;
    }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: body,
      });

      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}`, fetchConfig);

      if (!res.ok) {
        // Extract error message from backend response
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to update subset: ${res.statusText}`);
      }

      return res.json();
    },
    onSuccess: (data) => {
      toast.success('Subset updated successfully');
      // Invalidate both the specific subset and the subset list
      queryClient.invalidateQueries({ queryKey: [QueryEntity.DocSubsets, { matterId: data.matterId }] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Case, data.id] });
    },
    onError: (error: Error) => {
      console.error('Update subset error:', error);
      toast.error('Failed to update subset. Please try again.');
    },
  });
};
